import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface EditorState {
  content: string;
  isDirty: boolean;
  cursorPosition: { line: number; column: number };
  selection: { start: number; end: number } | null;
  language: string;
  fontSize: number;
  wordWrap: boolean;
  minimap: boolean;
}

const initialState: EditorState = {
  content: '',
  isDirty: false,
  cursorPosition: { line: 1, column: 1 },
  selection: null,
  language: 'markdown',
  fontSize: 14,
  wordWrap: true,
  minimap: false,
};

const editorSlice = createSlice({
  name: 'editor',
  initialState,
  reducers: {
    setContent: (state, action: PayloadAction<string>) => {
      state.content = action.payload;
      state.isDirty = true;
    },
    setClean: (state) => {
      state.isDirty = false;
    },
    setIsDirty: (state, action: PayloadAction<boolean>) => {
      state.isDirty = action.payload;
    },
    setCursorPosition: (state, action: PayloadAction<{ line: number; column: number }>) => {
      state.cursorPosition = action.payload;
    },
    setSelection: (state, action: PayloadAction<{ start: number; end: number } | null>) => {
      state.selection = action.payload;
    },
    setLanguage: (state, action: PayloadAction<string>) => {
      state.language = action.payload;
    },
    setFontSize: (state, action: PayloadAction<number>) => {
      state.fontSize = action.payload;
    },
    toggleWordWrap: (state) => {
      state.wordWrap = !state.wordWrap;
    },
    toggleMinimap: (state) => {
      state.minimap = !state.minimap;
    },
  },
});

export const {
  setContent,
  setClean,
  setIsDirty,
  setCursorPosition,
  setSelection,
  setLanguage,
  setFontSize,
  toggleWordWrap,
  toggleMinimap,
} = editorSlice.actions;

export const editorReducer = editorSlice.reducer;
